module.exports = __webpack_public_path__ + "static/img/summer_jianjiePic.46661ed6.png";